module.exports = {".FV .FV-layout-wr":{"max-width":["880px","780px","700px","580px","510px"]}}


/*****************
 ** WEBPACK FOOTER
 ** ./assets/stylesheets/elementQuery.json
 ** module id = 766
 ** module chunks = 0
 **/